/**
 * Generated runtime TestId mirror for frontend/src/pages/InboundConnectorDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const InboundConnectorDetailTestIds = {
  btnDelete: "btn-delete",
  btnTestConnection: "btn-test-connection",
  btnToggleEnabled: "btn-toggle-enabled",
  deleteConfirmDialog: "delete-confirm-dialog",
  detailTabs: "detail-tabs",
  inboundConnectorDetailPage: "inbound-connector-detail-page",
  lastSyncCreatedCount: "last-sync-created-count",
  lastSyncErroredCount: "last-sync-errored-count",
  lastSyncUpdatedCount: "last-sync-updated-count",
  tabConfiguration: "tab-configuration",
  tabOverview: "tab-overview",
  tabSyncRuns: "tab-sync-runs",
  testResultDialog: "test-result-dialog"
} as const;
